import React from 'react';
import { Button } from 'antd';
import classNames from 'classnames';
import styles from './AppliedSourceTag.module.scss';
import ScheduleInterviewButton from '../../CandidateCard/ScheduleInterviewButton';

export default function AppliedSourceTag(props) {
  const { sourceName, showViewApplicationButtonInDrawer, formattedPortalUrl, candidate, user, isScheduleInterview } =
    props;
  let appliedTagText = 'Applied';
  const joinedText = ' via ';
  if (sourceName) {
    appliedTagText =
      sourceName === 'ChatBot'
        ? appliedTagText.concat(' via Text Agent')
        : appliedTagText.concat(joinedText, sourceName);
  }

  return (
    <div className={styles.appliedSourceTagWrapper}>
      <div className={classNames(styles.appliedSourceTag, styles.candidate360AppliedSourceTag)}>{appliedTagText}</div>
      {isScheduleInterview ? <ScheduleInterviewButton candidate={candidate} userEmail={user?.email} /> : null}
      {showViewApplicationButtonInDrawer && (
        <Button
          type="link"
          className={styles.applicationReviewBtn}
          onClick={e => {
            e.stopPropagation();
            window.open(formattedPortalUrl, '_blank');
          }}
        >
          View Application
        </Button>
      )}
    </div>
  );
}
